var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M13.111 38a1 1 0 01-1 1H11a1 1 0 01-1-1V10a1 1 0 011-1h1.111a1 1 0 011 1v1.244c2.393-.707 4.753-.85 7.08-.43 5.318.964 7.64 2.223 10.38 2.223 6.221 0 7.429-4.135 7.429-1.28v14.691a1 1 0 01-.442.83c-2.23 1.499-4.558 2.248-6.988 2.248-3.886 0-5.99-2.486-10.06-3.271-3.255-.629-5.722-.39-7.399.715V38z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
